import { useState } from "react";
import { faqs } from "@/mocks/faqs";
import SectionHeading from "./SectionHeading";

export default function FaqSection() {
  const [openId, setOpenId] = useState<string | null>(faqs[0]?.id ?? null);

  return (
    <section id="faq" className="section-anchor w-full bg-background-50">
      <div className="w-full px-4 md:px-8 py-14 md:py-24">
        <div className="max-w-4xl mx-auto">
          <SectionHeading
            eyebrow="常见问题"
            title="关于潘金莲电影合集与推荐的常见疑问"
            desc="下面整理了几个在浏览这一题材时最常被问到的问题，点击标题即可展开查看。"
            align="center"
          />

          <div className="mt-10 space-y-3">
            {faqs.map((faq) => {
              const isOpen = openId === faq.id;
              return (
                <div
                  key={faq.id}
                  className="rounded-lg border border-background-200/70 bg-background-50 overflow-hidden"
                >
                  <button
                    type="button"
                    onClick={() => setOpenId(isOpen ? null : faq.id)}
                    aria-expanded={isOpen}
                    className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer hover:bg-background-100 transition-colors"
                  >
                    <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-950">
                      {faq.q}
                    </h3>
                    <span className="shrink-0 w-7 h-7 flex items-center justify-center rounded-full bg-primary-100 text-primary-700">
                      <i
                        className={
                          isOpen ? "ri-subtract-line" : "ri-add-line"
                        }
                      ></i>
                    </span>
                  </button>
                  <div
                    className={`overflow-hidden transition-all duration-300 ${
                      isOpen ? "max-h-[400px]" : "max-h-0"
                    }`}
                  >
                    <div className="px-5 pb-5 -mt-1">
                      <p className="text-sm leading-relaxed text-foreground-700">
                        {faq.a}
                      </p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}